export const buildTrialInfoOrUndefined = (data) => {
    if (!data)
        return undefined;
    const trialInfo = {
        planInterval: data.planInterval || '',
        trialStartDate: data.trialStartDate || 0,
        trialDaysRemaining: data.trialDaysRemaining || 0,
        planId: data.planId || 'FREE_2016',
        seats: data.seats || 0,
        paidCustomerInPast: data.paidCustomerInPast || false,
        trialEndDate: data.trialEndDate || 0,
    };
    return trialInfo;
};
